import { formatBRL } from "@/lib/format";
// Small pure helpers to describe a proposal's items in one line — shared by
// the admin cards, the copied text and the PDFs so the wording matches.

export interface SummarizableItem {
  title: string;
  pricing_mode: string;
  hours: number | null;
  hourly_rate: number | null;
  fixed_price: number | null;
  monthly_amount: number | null;
  subtotal: number;
}

const fmt = (v: number) => formatBRL(v);

export function totalHours(items: SummarizableItem[]): number {
  return items.reduce((s, i) => s + (i.pricing_mode === "hourly" ? (i.hours ?? 0) : 0), 0);
}

/** "12h" for hourly items, "1" for fixed/recurring ones (quantity column). */
export function itemQty(item: SummarizableItem): string {
  return item.pricing_mode === "hourly" ? `${item.hours ?? 0}h` : "1";
}

/** Unit price column: R$/h for hourly, R$/mês for recurring, the fixed price otherwise. */
export function itemUnit(item: SummarizableItem): string {
  if (item.pricing_mode === "hourly") return `${fmt(item.hourly_rate ?? 0)}/h`;
  if (item.pricing_mode === "recurring") return `${fmt(item.monthly_amount ?? item.subtotal)}/mês`;
  return fmt(item.fixed_price ?? item.subtotal);
}

/** "10h × R$ 80,00/h", "Fixo: R$ 2.500,00", "R$ 150,00/mês" or "3 serviços · 24h". */
export function budgetLineSummary(items: SummarizableItem[]): string {
  if (items.length === 0) return "Sem itens";
  if (items.length === 1) {
    const it = items[0];
    if (it.pricing_mode === "hourly") return `${it.hours ?? 0}h × ${fmt(it.hourly_rate ?? 0)}/h`;
    if (it.pricing_mode === "recurring") return `${fmt(it.monthly_amount ?? it.subtotal)}/mês`;
    return `Fixo: ${fmt(it.fixed_price ?? it.subtotal)}`;
  }
  const h = totalHours(items);
  return `${items.length} serviços${h > 0 ? ` · ${h}h` : ""}`;
}
